// extracted by mini-css-extract-plugin
export default {"society":"index_society_savOB"};